/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SupportInputs */



/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const contact_support = /** @type {((inputs?: Contact_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contacter le support")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontaktieren Sie den Support.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contatta l'assistenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Связаться со службой поддержки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contactar con soporte técnico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("联系客服")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポートに問い合わせる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समर्थन से संपर्क करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contate o suporte")
	return /** @type {LocalizedString} */ ("Contact Support")
});